import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EmailRendererTestResult} from './email-renderer-test-result/email-renderer-test-result';
import {map} from 'rxjs/operators';
import {SerializedEmailRendererTestResult} from './email-renderer-test-result/serialized-email-renderer-test-result';

@Injectable()
export class EmailRendererTestResultsService {
    constructor(private httpClient: HttpClient) {
    }

    /**
     *
     * @param testId
     */
    public get(testId: string): Observable<Array<EmailRendererTestResult>> {
        return this.httpClient.get<object>(`https://api.emailonacid.com/v5/email/tests/${testId}/results/`, {
            headers: {
                Authorization: `Basic ${btoa('Y1Koj3MKhYfiz5SAgGTBTluRJy3Z8P7nwJjT3UDC:7Fk0G2KVUiRaNnT6sH8v')}`
            }
        }).pipe(map((serializedEmailRendererResults: object) => {
            return Object.values(serializedEmailRendererResults).map((serializedEmailRendererResult: SerializedEmailRendererTestResult) => {
                return new EmailRendererTestResult({
                    client: serializedEmailRendererResult.display_name,
                    id: serializedEmailRendererResult.id,
                    screenshot: serializedEmailRendererResult.screenshots.default,
                    thumbnail: serializedEmailRendererResult.thumbnail
                });
            });
        }));
    }
}
